import { render } from "./SupportCommande.vue?vue&type=template&id=ac8187a2"
import script from "./SupportCommande.vue?vue&type=script&lang=ts"
export * from "./SupportCommande.vue?vue&type=script&lang=ts"
script.render = render

export default script